const featuredPlanetNames = [
  "Tatooine",
  "Coruscant",
  "Naboo",
  "Geonosis",
  "Kamino",
  "Utapau",
  "Mustafar",
  "Kashyyyk",
  "Alderaan",
  "Yavin IV",
  "Hoth",
  "Dagobah",
  "Bespin",
  "Endor",
];

export default featuredPlanetNames;